<template>
  <div id="home" class="article-page" :style="cssHeaderHeight">
    <template v-if="!canShowContent">
      <div>Content not Found</div>
    </template>
    <template v-else>
      <CustomHead :head="head" />
      <ArticleHeader :content="content" ref="article-header" />
      <Section class="article-page__content" :class="{'--visible-newsletter': visibleNewsletter, '--sticky-newsletter': isStickyNewsletter}">
        <div class="mks-grid mks-grid-gap-xl">
          <div class="mks-col-12 mks-col-7@md render-content">
            <mks-spacer class="article-page__metas" inline align="center">
              <mks-spacer inline spacing="m">
                <span v-if="firstPublished"><mks-icon type="calendar" size="15"></mks-icon> {{ firstPublished }}</span>
                <span v-if="author"><mks-icon type="user" size="15"></mks-icon> par {{ author }}</span>
                <span v-if="timeToRead"><mks-icon type="clock" size="15"></mks-icon> {{timeToRead}} minutes de lecture</span>
                <span v-if="profile && profile.role === 'admin'" title="Nombre de vues (admin only)"><mks-icon type="eye" size="15"></mks-icon> {{content.count}}</span>
              </mks-spacer>
            </mks-spacer>
            <CustomRenderContent model="article" :content="content" class="article-content" ref="articleContent" />
            <NewsletterCard
              v-if="content.data.thematique.value.data.slug !== 'entrepreneuriat'"
              article
              image="https://cdn.builder.io/api/v1/image/assets%2F6699e11b753c40d5a84d90175d459363%2F44208ceea4f44b58a9695275f06aaa11"
              title-before="Envie de plus de contenus&nbsp;? Laisse&#8209;nous ton mail (et tes états d’âme)"
              title-bean=""
              title-after=""
              description="Si tu veux des bons plans, des articles sympas et des événements à ne pas manquer, rejoins notre communauté&nbsp;!"
              call-to-action="Rejoindre la communauté"
              source="articles-sticky"
              :close="showNewsletterCloseButton"
              @close="closeNewsletter()"
            />
            <NewsletterCard
              v-else
              article
              theme="entrepreneuriat-footer"
              image="https://cdn.builder.io/api/v1/image/assets%2F6699e11b753c40d5a84d90175d459363%2F3e3840d419b5469eb49d82efb8078721"
              title-before="C'est dans la "
              title-bean="boîte"
              title-after=""
              description="La newsletter avec l’essentiel pour entreprendre sereinement, efficacement et avec engagement."
              call-to-action="S'abonner"
              source="articles-sticky"
              destination="spot"
              :close="showNewsletterCloseButton"
              @close="closeNewsletter()"
            />
            <!--RenderContent model="article" :content="content" :api-key="apiKey" :customComponents="getCustomComponents" /-->
            <!--hr class="separator" /-->
            <mks-spacer inline align="center" class="article-prefooter">
              <div class="article-footer__partnership" v-if="content && content.data && content.data.sponsoredBy">
                <SponsoredBy :link="content.data.sponsoredBy.value.data.link"
                  :logo="content.data.sponsoredBy.value.data.logo" :partner="content.data.sponsoredBy.value.data.partner" />
              </div>
              <mks-spacer inline align="center" v-if="content.data.tags && content.data.tags.length > 0">
                <template v-for="tag in content.data.tags" :key="tag">
                  <mks-link :to="`/media/tag/?tag=${tag}`" type="menu">
                    <mks-button size="small" type="neutral" >{{ tag }}</mks-button>
                  </mks-link>
                </template>
              </mks-spacer>
              <mks-spacer-item :push="content && content.data && content.data.sponsoredBy ? 'right' : undefined" v-if="share">
                <Share :url="share.url" :title="share.title" :description="share.description" />
              </mks-spacer-item>
            </mks-spacer>
          </div>
          <ArticleSidebar :topic="content.data.thematique" />
        </div>
      </Section>  

      <Section class="action-cards-section" background="primary" v-if="actionCards?.length >= 3">
        <mks-spacer spacing="l">
          <mks-heading tag="h2" tag-class="h2" color="neutral-100" class="action-cards-title">
            <span>Mode</span>
              <DisplayBean text="Action" colorText="primary" color="secondary">
              </DisplayBean>
            <span>activé</span>
          </mks-heading>
          <Carousel
            :showNavigation="true"
            :slides-per-view="2.8"
            limitSlidesForLargeScreens
            viewMoreLink="/actions"
            viewMoreLabel="Découvrir"
            viewMoreColor="secondary"
            navColor="secondary"
          >  
            <ActionCard v-for="actionCard in actionCards" :action="actionCard" @click="trackActionCard" fullWidth></ActionCard>
          </Carousel>
        </mks-spacer>
      </Section>


      <Section v-if="related && related.length" class="article-page__related" :class="actionCards?.length && '--with-actions'">
        <mks-spacer spacing="l">
          <mks-heading tag="h2" tag-class="h2">
            Contenus <DisplayBean text="random" color="calypso"></DisplayBean> pour kiffer
          </mks-heading>
          <Carousel :showNavigation="true" navColor="primary" :slides-per-view="3">
            <template v-for="item in related">
              <ArticleTeaser v-if="item.builderId" :key="item.builderId" :content="item" variant="spotlight" @click="trackRandom"></ArticleTeaser>
              <EventTeaser v-else :event="item" variant="spotlight" :key="item._id" @click="trackRandom"></EventTeaser>
            </template>
          </Carousel>
        </mks-spacer>
      </Section>
      <Section tag="ArticleFooter" :content="content" />
    </template>
  </div>
</template>

<script>
import { isPreviewing } from '@builder_sdk';
import { REGISTERED_COMPONENTS } from '@/init-builder.ts';
import { useAsyncData } from 'nuxt/app';
import { useRoute } from 'vue-router';
import { mapGetters } from 'vuex';
import ArticleHeader from "@/components/organisms/Article/Header.vue";
import ArticleFooter from "@/components/organisms/Article/Footer.vue";
import ArticleSidebar from "@/components/organisms/Article/Sidebar.vue";
import chicheMetas from '@/mixins/chicheMetas';
import CustomRenderContent from "@/components/organisms/RenderContent/CustomRenderContent.vue";

export default defineNuxtComponent({
  name: 'ArticlePage',
  components: {
    ArticleFooter, ArticleHeader, ArticleSidebar, CustomRenderContent
  },
  mixins: [chicheMetas],
  data() {
    return {
      canShowContent: false,
      content: null,
      articleHeaderHeight: '520px', // magic number: height on mobile
      loading: true,
      stickyNewsletter: false,
      visibleNewsletter: false,
      newsletterClosed: false,
      showNewsletterCloseButton: true
    }
  },
  computed: {
    ...mapGetters('user', ['profile']),
    head() {
      if (!this.content) return;
      const head = this.getHead(this.content.data, [{ type: 'article', data: this.content }]);

      return head;
    },
    apiKey() {
      return this.$env.builder.apiKey;
    },
    getCustomComponents() {
      return REGISTERED_COMPONENTS;
    },
    cssHeaderHeight() {
      // if (this.profile && this.profile.active && this.articleHeaderHeight) {
      //   // to reload computed value when this changes
      // }
      if (process.client) {
        return '--article-header-height:' + this.articleHeaderHeight + 'px';
      }
      // magic number for the article header on desktop
      return '--article-header-height: 720px;';
    },
    firstPublished() {
      if (!this.content) return;
      if (this.content?.data?.customDate) {
        return this.$dayjs(this.content.data.customDate).hour(12).format('DD MMMM YYYY');
      }
      if (this.content.firstPublished) return this.$dayjs(new Date(this.content.firstPublished)).format('DD MMMM YYYY');
      else return this.$dayjs(new Date(this.content.createdDate)).format('DD MMMM YYYY'); // pas publié 
    },
    author() {
      if (!this.content) return;
      const author = this.content.data.auteurice;
      if (author && author.value && author.value.data) {
        return author.value.data.name || (author.value.data.firstname + ' ' + author.value.data.lastname)
      }
    },
    timeToRead() {
      if (!this.content || !this.content.data || !this.content.data.blocks) return;
      const textComponents = this.content.data.blocks
        .filter(block => block.component && block.component.name == 'Text')
        .map(block => block.component.options.text)
        .join();
      const wordCount = textComponents.trim().split(/\s+/).length;
      // 238 is the average count of word read per minute
      return Math.round(wordCount / 238);
    },
    share() {
      if (!this.content || !this.content.data) return;
      return {
        url: `${this.$env.eventsUrl}${this.$route.path}?utm_source=chiche&utm_medium=share&utm_campaign=share-footer`,
        title: `${this.content.data.title} - Chiche by makesense`,
        description: `${this.content.data.descriptionCourte}`
      }
    },
    isStickyNewsletter() {
      return this.stickyNewsletter && !(this.profile?.mailchimpSubscriber);
    }
  },
  created() {
    if (process.client) {
      window.addEventListener('resize', this.onResize, false);
      this.onResize();
    }
  },
  async mounted() {
    // Re-run this check on the client in case of SSR
    this.canShowContent = this.content || isPreviewing();
    if (process.client) {
      window.addEventListener('resize', this.onResize, false);
      window.addEventListener('scroll', this.onScroll, false);
      this.onResize();
    }

    // console.log('slug', this.$route.params.slug);
    this.$api.Builder.track(this.$route.params.slug);
    const readArticlesCookie = document.cookie.match('(^|;) ?' + 'makesense_events_read_articles' + '=([^;]*)(;|$)');
    let readArticles = parseInt(readArticlesCookie?.[2]);
    if (!readArticles) {
      readArticles = 0;
    }
    if (readArticles >= 5 && !(this.profile?.mailchimpSubscriber)) {
      this.shouldLock = true;
      this.$store.dispatch("analytics/track", {
        event: "Makesense Chiche - Article Lock - Displayed",
        data: {
          slug: this.$route.params.slug
        }
      });
    }
    else {
      document.cookie = `makesense_events_read_articles=${readArticles + 1}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    }

    // document.body.addEventListener('scroll', this.onScroll, false);
  },
  destroyed: function () {
    if (process.client) {
      window.removeEventListener('resize', this.onResize, false);
      window.removeEventListener('scroll', this.onScroll, false);
    }
  },
  async setup() {
    const nuxtApp = useNuxtApp();
    const data = {};

    if (nuxtApp.$env.SITE === 'international') {
      await navigateTo('/')
    }
    
    try {
      const route = useRoute();

      const previewing = route.query.previewing === 'true';

      const params = {
        includeUnpublished: previewing,
        query: {
          data: {
            slug: route.params.slug
          }
        }
      };
      const { data: content } = await useAsyncData(() => nuxtApp.$builder.getOne('article', params));

      let { $article } = nuxtApp;
      $article.value = content.value;

      data.content = content.value;
      data.content.data.blocks = data.content?.data?.blocks?.filter((block) => block?.component?.name !== 'NewsletterCard');
      data.canShowContent = (!!data.content && data.content.data.status.toLowerCase() === 'publié') || isPreviewing() || previewing;

      if (content && content.value && content.value.data) {
        const relatedPromise = useAsyncData(() => nuxtApp.$api.Builder.queryContent({
          topics: content.value.data.thematique.value.data.id,
          pillars: content.value.data.pilier.value.data.id,
          tags: content.value.data.tags,
          exclude: content.value.id
        }));
        const actionCardsPromise = useAsyncData(() => nuxtApp.$builder.getAll('carte-action', {
          options: {
            sort: '-publishedAt'
          },
          query: {
            "data.thematiques.thematique.value.data.id": content.value.data.thematique.value.data.id
          }
        }));

        const [{ data: related }, {data: actionCards}] = await Promise.all([
          relatedPromise,
          actionCardsPromise
        ]);
        const shuffleSeed = nuxtApp.$dayjs().startOf('day').valueOf();
        data.related = related;
        data.actionCards = nuxtApp.$prngShuffle(actionCards?.value?.results || [], shuffleSeed).slice(0, 3);
      }
      
      // if (data.content && data.content.data && route.params.category.toLowerCase() !== data.content.data.thematique.value.data.slug.toLowerCase()) {
      //   console.log('__________');
      //   console.log('not the right category, should redirect', route.params.category, data.content.data.thematique.value.data.slug);
      // TODO : redirect to the right category
      // let category = content.data.thematique.value.data.slug;
      // router.replace({name: route.path, query: {...route.query, category}})
      // redirectTo = {path: route.path, query: {...route.query, category}};

      // } else {
      //   console.log('right category, do nothing')
      // }
    }
    catch (err) {
      console.log('ERROR in article setup', err);
    }

    if (!data.canShowContent) {
      console.log('no content');

      throw createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true });
    }

    return data;
  },
  methods: {
    onResize() {
      if (!this.$refs.articleHeader) return;
      this.articleHeaderHeight = this.$refs.articleHeader.offsetHeight;
    },
    onScroll() {
      this.stickyNewsletter = !this.newsletterClosed && window.scrollY >= 0;
      this.visibleNewsletter = this.newsletterClosed || window.scrollY >= window.innerHeight;
      this.showNewsletterCloseButton = this.$refs.articleContent.$el.getBoundingClientRect().bottom > window.innerHeight;
    },
    closeNewsletter() {
      this.newsletterClosed = true;
      this.visibleNewsletter = false;
      setTimeout(() => {
        this.stickyNewsletter = false;
        this.visibleNewsletter = true;
      }, 400);
    },
    trackRandom() {
      this.$store.dispatch("analytics/track", {
        event: "Makesense Chiche - Article - Click contenus random",
        data: {
          slug: this.$route.params.slug
        }
      });
    },
    unlock(subscribed, dismiss) {
      this.shouldLock = false;
      document.cookie = `makesense_events_read_articles=0; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
      if (subscribed) {
        this.$store.dispatch("analytics/track", {
          event: "Makesense Chiche - Article Lock - Subscribed",
          data: {
            slug: this.$route.params.slug
          }
        });
      }
      else {
        this.$store.dispatch("analytics/track", {
          event: "Makesense Chiche - Article Lock - " + (dismiss ? 'Dismissed' : 'Closed'),
          data: {
            slug: this.$route.params.slug
          }
        });
      }
    },
    trackActionCard() {
      this.$store.dispatch("analytics/track", {
        event: "Makesense Chiche - Article - Click Action Card",
        data: {
          slug: this.$route.params.slug
        }
      });
    }
  },
  watch: {
    content() {
      if (process.client) {
        window.addEventListener('resize', this.onResize, false);
        this.onResize();
      }
    }
  }
});
</script>
<style lang="scss">
.article-page {
  // padding-top: var(--header-height);
  position: relative;
}

.article-page__content {
  margin-top: $space-xxl;
  padding-bottom: 0;

  .newsletter-card--article {
    transform: translateY(20%);
    opacity: 0;
    transition: all 0.3s;
    margin: $space-l 0;

    width: 90%;
  }

  &.--visible-newsletter {
    .newsletter-card--article {
      transform: translateY(0);
      opacity: 1;
    }
  }
  &.--sticky-newsletter {
    .newsletter-card--article {
      position: sticky;
      bottom: $space-m;
    }
  }

  :slotted(.builder-blocks) {
    background-color: #000;
  }

  @include breakpoint('medium', 'max') {
    margin-top: $space-l;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  @include breakpoint('small', 'max') {
    display: block;
    margin-top: 0;
    padding-top: 0;
  }
}

.article-page__related {
  overflow-x: hidden;

  &.--with-actions {
    padding-top: $space-xxl;
  }
}

.article-page__metas {
  margin-bottom: $space-l;

  @include breakpoint('small', 'max') {
    font-size: $font-size-s;
  }
}

.article-prefooter {
  margin-top: $space-l;
  margin-bottom: $space-l;

  @include breakpoint('medium', 'max') {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.article-page .render-content {

  .builder-blocks > :first-child {
    margin-top: 0;

    @include breakpoint('small') {
      margin-top: $space-l;
    }
  }

  .builder-blocks > :first-child > :first-child * {
    font-size: var(--font-size-xl) !important;
    letter-spacing: var(--letter-spacing-small) !important;
    font-weight: $font-weight-black !important;
    font-family: $font-heading !important;
    line-height: 1.25;

    @include breakpoint('small') {
      font-size: var(--font-size-xxl) !important;
      line-height: 1.15;
    }
  }

  .builder-block .builder-text,
  .builder-block .builder-text span,
  .builder-block .builder-text p,
  .builder-block .builder-text em {
    @include text-large;
    line-height: $line-height-l;
  }

  .builder-image {
    border-radius: $border-radius-l;
    outline: 1px;
  }

  .builder-block:not(.no-bean) .builder-image {
    transition: all .5s ease-out;

    &:hover {
      border-radius: 70%/100%;
      transition: all .5s ease-in;
      // transform: scale(1.01);
    }
  }

}

.article-footer__partnership {
  @include text-small;

  .icon {
    stroke: $color-brick-red;
    fill: $color-brick-red;
  }
}

.partnership__logo {
  max-width: 110px;
  max-height: 80px;
}

.article-locked {
  position: relative;
  height: 1300px;
  overflow: hidden;
  margin-bottom: $space-xl;
  

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 450px;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 10%, rgba(255,255,255,1) 100%);
    z-index: 100;
  }

  .lock {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 101;

    &-message {
      font-size: $font-size-m;
      font-weight: $font-weight-bold;
      text-align: center;
      padding: $space-m;
    }

    &-card {
      display: flex;
      flex-direction: row;     
      border-radius: 30px;
      overflow: hidden;
      height: 330px;
      position: relative;
    }

    &__left {
      width: 37%;
      position: relative;
    }

    &__right {
      width: 63%;
      background: $color-primary;
      padding: $space-l;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    &__close {
      display: inline-block;
      margin-top: $space-s;
      &:hover {
        color: $color-neutral-80;
      }
    }

    &__title {
      font-weight: $font-weight-black;
    }

    &__img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__team {
      position: absolute;
      bottom: 0;
      left: 20%;
      width: 60%;
      background: #fff;
      padding: $space-xs $space-m 0 $space-m;
      border-radius: 10px 10px 0 0;
      font-size: 18px;
      text-align: center;
    }

    &__dismiss {
      position: absolute;
      top: $space-s;
      right: $space-s;
      color: $color-default;
      cursor: pointer;
    }

    @include breakpoint('small', 'max') {
      &-card {
        flex-direction: column;
        height: auto;
      }

      &__left {
        width: 100%;
        aspect-ratio: 2 / 1;
        order: 1;
        overflow: hidden;
      }
      
      &__right {
        width: 100%;
        order: 0;
      }

      &__text, &__title {
        text-align: center;
        margin-bottom: $space-s;
      }

      &__close-container {
        text-align: center;
        margin-top: $space-m;
      }
      &__close {
        display: inline;
      }
      &__team {
        display: none;
      }

      &__img {
        height: auto;
        top: -90px;
      }

      &-message {
        position: relative;
      }

      &-message:before {
        content: "";
        position: absolute;
        top: -20%;
        left: 0;
        height: 150%;
        width: 100%;
        background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 10%, rgba(255,255,255,1) 100%);
        z-index: -1;
      }
    }
  }
}

.action-cards-section {
  border-top-right-radius: 45px;
  border-top-left-radius: 45px;
  padding-top: 30px;
  margin-top: $space-l;
  overflow-x: hidden;

  @include breakpoint('small', 'min') {
    border-top-left-radius: 70px;
    border-top-right-radius: 70px;
    padding-top: 60px;
  }
}

.action-cards {
  gap: $space-l;

  display: grid;
  grid-template-columns: repeat(auto-fit, 30%);
  justify-content: center;
  align-items: flex-start;

  @include breakpoint('medium', 'max') {
    grid-template-columns: repeat(auto-fit, 40%);
  }
  @include breakpoint('small', 'max') {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-template-columns: none;
    // grid-template-columns: repeat(auto-fit, 90%);
    .action-card {
      width: 90%;
    }
  }
}


.action-button {
  display: block;
  margin-bottom: $space-l;
}
</style>
